import React from 'react';
import { SectionHeader } from '../ui/SectionHeader';
import { Reveal } from '../ui/Reveal';
import { LinkButton } from '../ui/Button';
import { whyItems } from '../../data/services';
export function WhyAndrea() {
  return <section className="bg-teal py-20 text-white lg:py-32" data-id="element-269" data-mp="2w8mid7run21v">
      <div className="mx-auto max-w-shell px-5 lg:px-10" data-id="element-270" data-mp="2rb4j693mw172">
        <SectionHeader eyebrow="¿Por qué trabajar conmigo?" tone="light" title={<>
              Una asesoría pensada
              <br data-id="element-272" data-mp="1yn8otb1jeldg" />
              para ti.
            </>} data-id="element-271" data-mp="2rbmmtqsmlhp0" />

        <ol className="mt-14 grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:mt-20 lg:grid-cols-4" data-id="element-273" data-mp="2dj6d6757ylf4">
          {whyItems.map((item, i) => <li key={item.n} data-id="element-274" data-mp="28jk3g7olnnb2" data-mpi={i}>
              <Reveal delay={i * 0.07} data-id="element-275" data-mp="28mg3c1k0cm25">
                <span className="font-display text-[13px] font-semibold tracking-[0.2em] text-gold" data-id="element-276" data-mp="3oy3gmm25hd60">
                  {item.n}
                </span>
                <div className="mt-4 h-px w-full bg-white/15" data-id="element-277" data-mp="3jz8mwp2na474" />
                <h3 className="mt-5 font-display text-[14px] font-semibold tracking-[0.12em] text-white" data-id="element-278" data-mp="2t5p3kbe563t8">
                  {item.title}
                </h3>
                <p className="mt-3 text-[13.5px] font-light leading-relaxed text-white/60" data-id="element-279" data-mp="334y4jo7fcip3">
                  {item.text}
                </p>
              </Reveal>
            </li>)}
        </ol>

        <Reveal className="mt-16 border-t border-white/10 pt-14 lg:mt-24 lg:pt-16" data-id="element-280" data-mp="2ag8xl8jotj5f">
          <blockquote className="mx-auto max-w-3xl text-center" data-id="element-281" data-mp="2aefsvysmx902">
            <p className="font-display text-[22px] font-medium leading-[1.4] text-white sm:text-[28px] lg:text-[32px]" data-id="element-282" data-mp="2ffvcrnj2t9gv">
              “No se trata solamente de elegir un seguro.
              <br className="hidden sm:block" data-id="element-283" data-mp="2o8p78s73gffb" /> Se trata de{' '}
              <span className="text-beige" data-id="element-284" data-mp="1rprdfscx7vvo">entender qué estás protegiendo</span>.”
            </p>
            <LinkButton href="#agenda" variant="light" size="lg" className="mt-10" data-id="element-285" data-mp="1vrcu7osksub5">
              QUIERO HABLAR CON ANDREA
            </LinkButton>
          </blockquote>
        </Reveal>
      </div>
    </section>;
}